export default __webpack_public_path__ + "static/media/studyMaterial.081f3794.svg";